import * as React from 'react';

import * as styles from './MobileCallButtonLayout.css';

interface IMobileCallButtonLayoutProps {
  ['data-testid']?: string;
}

export const MobileCallButtonLayout: React.FC<React.PropsWithChildren<IMobileCallButtonLayoutProps>> = props => {
  return (
    <div className={styles['layout']} data-testid={props['data-testid']}>
      {props['children']}
    </div>
  );
};
